import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useAuth } from '@/hooks/use-auth'
import { useCompanies } from '@/hooks/use-companies'
import { getProjects } from '@/services/get-projects'
import { Project } from '@/types/projects'

type HandleErrorMessage = (error: {
  title: string
  description: string
}) => void

const transformRawProjects = (projects: Project[]) =>
  projects.map((projects) => {
    const localization = [projects.address.city, projects.address.state].join(
      ', ',
    )

    return {
      id: projects.id,
      name: projects.name,
      private: projects.private,
      localization,
    }
  })

export const GET_PROJECTS_QUERY = 'projects'

export const useGetProjects = (handleErrorMessage?: HandleErrorMessage) => {
  const { selectedCompany } = useCompanies()
  const { user } = useAuth()

  const query = useQuery(
    [GET_PROJECTS_QUERY, selectedCompany.id],
    ({ signal }) => getProjects(selectedCompany.id, user.id, signal),
    {
      select: transformRawProjects,
      onSuccess: (data) => {
        !data.length &&
          handleErrorMessage?.({
            title: 'Nenhuma unidade cadastrada.',
            description: 'Adicione uma nova unidade.',
          })
      },
      onError: (err: Error) => {
        handleErrorMessage?.({
          title: 'Ocorreu um erro',
          description: err.message,
        })
      },
    },
  )

  useEffect(() => {
    if (query.errorUpdateCount > 3) return query.remove
  }, [query.errorUpdateCount])

  return query
}
